import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
// import { Link } from 'react-router-dom';

export const CommonTnc = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Trans i18nKey="common.termNPolicy" style={{ marginLeft: '20px', fontSize: '17px' }}>
      {[
        <a
          key="termsNConditions"
          href={t('settings.legalInformationLink')}
          // to={`/EN_US/privacy_security_cookies`}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />,
        <a
          key="privacyPolicy"
          href={t('settings.privacySecurityCookiesLink')}
          // to={`/privacy-policy?lan=${i18n.language}`}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />,
        <a
          key="personalInfoCollectionDoc"
          href={t('settings.privacyPolicyLink')}
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        />,
      ]}
    </Trans>
  );
};
